module.exports = __webpack_public_path__ + "static/media/pic-history.691a2dda.webp";